module.exports = __webpack_public_path__ + "img/button_stop.509f8a4b.png";